var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('q-btn',{staticClass:"q-mx-sm",attrs:{"icon":_vm.homeIcon,"to":"/home","flat":"","round":"","dense":""},on:{"click":_vm._onClick}},[_c('q-tooltip',[_vm._v(_vm._s(_vm.$t('names.home')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }